import { autoinject } from "aurelia-framework";
import { HttpClientService } from "../../services/http-client-service";
import { AdminPumpentyp } from "./admin-pumpentyp";

@autoinject
export class AdminService {
  constructor(private httpClientService: HttpClientService) {}

  getAdminPumpentyp(id: number): Promise<AdminPumpentyp> {
    return this.get<AdminPumpentyp>(`admin/pumpentyp/${id}`);
  }

  deletePumpentyp(id: number): Promise<string> {
    return this.delete<string>(`admin/pumpentyp/${id}`);
  }

  private async get<T>(url: string): Promise<T> {
    const r = await this.httpClientService.get().get(url);
    return r.content;
  }

  private async delete<T>(url: string): Promise<T> {
    const r = await this.httpClientService.get().delete(url);
    return r.content;
  }
}
